export default function Footer() {
  return (
    <footer className="bg-gray-900 text-white py-12">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center space-y-8">
          <h3 className="text-2xl font-bold">CV | Foued Hassin</h3>

          <div className="flex justify-center gap-6 flex-wrap">
            <a
              href="https://www.instagram.com/foued.hassin.officiel/"
              title="Instagram"
              className="w-12 h-12 flex items-center justify-center bg-gradient-to-br from-purple-600 to-pink-500 rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-instagram-line text-xl"></i>
            </a>
            <a
              href="https://www.linkedin.com/in/foued-hassin-36250921b"
              title="LinkedIn"
              className="w-12 h-12 flex items-center justify-center bg-blue-700 rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-linkedin-box-fill text-xl"></i>
            </a>
            <a
              href="https://www.facebook.com/fouedhassin1996"
              title="Facebook"
              className="w-12 h-12 flex items-center justify-center bg-blue-600 rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-facebook-box-fill text-xl"></i>
            </a>
            <a
              href="https://x.com/fouedhassin"
              title="Twitter"
              className="w-12 h-12 flex items-center justify-center bg-black rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-twitter-x-fill text-xl"></i>
            </a>
            <a
              href="https://www.tiktok.com/@foued.hassin.official"
              title="TikTok"
              className="w-12 h-12 flex items-center justify-center bg-black rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-tiktok-fill text-xl"></i>
            </a>
            <a
              href="https://wa.me/21919013"
              title="WhatsApp"
              className="w-12 h-12 flex items-center justify-center bg-green-500 rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-whatsapp-fill text-xl"></i>
            </a>
            <a
              href="mailto:fouedhessin@gmail.com"
              title="Email"
              className="w-12 h-12 flex items-center justify-center bg-red-500 rounded-lg hover:scale-110 transition-transform cursor-pointer"
            >
              <i className="ri-mail-fill text-xl"></i>
            </a>
          </div>

          <div className="border-t border-gray-700 pt-8 space-y-2">
            <p className="text-gray-400">© 2025 copyright all right reserved</p>
            <p className="text-gray-400">
              Developer : <a href="https://www.instagram.com/foued.hassin.officiel/" className="text-blue-400 hover:text-blue-300 cursor-pointer whitespace-nowrap">Foued Hassin</a>
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
}
